import { message, DatePicker, Table, Button, Tag, Space, Select, Input, Checkbox } from "antd";
import axios from "axios";
import React, { useEffect, useState, useMemo } from "react";
import SearchComponent from "../../Masters/GeneralComponents/SearchComponent";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import SiteTreeSelectAuto from "../Components/SiteTreeSelectAuto";
import { InputWithLabel } from "../../Components/Components";
import moment from "moment";
import DateRange from "../../Reports/Components/DateRange";
import { editButtonType } from "../../Constants";
import useFilterOptions from "../../Components/useFilterOptions";
import SiteTreeMultiSelect from "../Components/SiteTreeMultiSelect";
import { ExportToExcelButton } from "../../Components/ExportToExcel";
import ImportPOFile from "../Components/ImportPOFile";

export default function InwardOutwardList({
    selectedOrg = {},
    permissions = {},

    editPath = "/inventory/inward-outward",
}) {
    let [searchParams, setSearchParams] = useSearchParams();

    // Using session storage to save it even if the user refreshes the page, If opened in new tab, then it will be empty
    // setItem is in the useEffect below
    const [selected, setSelected] = useState({
        dateRange: [
            sessionStorage.getItem("inwardOutward-dateRange")
                ? moment(JSON.parse(sessionStorage.getItem("inwardOutward-dateRange"))?.[0])
                : moment().subtract(1, "day"),
            moment(JSON.parse(sessionStorage.getItem("inwardOutward-dateRange"))?.[1]), // It will be undefined if no value is present in local storage and moment will take it as today's date
        ],
        sites: sessionStorage.getItem("inwardOutward-siteIds") ? JSON.parse(sessionStorage.getItem("inwardOutward-siteIds")) : [],
        inwardOrOutward: searchParams.get("report") === "outward" ? "outward" : "inward",
        dateType: "created",
    });

    const setSelectedKey = (key, value) => {
        setSelected((s) => ({
            ...s,
            [key]: value,
        }));
    };

    useEffect(() => {
        setSelectedKey("inwardOrOutward", searchParams.get("report") === "outward" ? "outward" : "inward");
    }, [searchParams.get("report")]);

    const [masterState, setMasterState] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    // The below var is memoized to avoid re-rendering of the filters when the data is changed
    // If not, the filters will be calculated again and again infinitely
    const filterableColumns = useMemo(() => ["status"], []);
    const [filterOptions, setFilterOptions] = useFilterOptions(masterState, filterableColumns);

    const getData = async () => {
        setLoading(true);
        const url = selected.inwardOrOutward === "outward" ? "/dashboard/outward_data" : "/dashboard/inward_data";
        await axios
            .post(url, {
                site_ids: selected.sites,
                from_date: selected.dateRange[0].startOf("day").format("YYYY-MM-DD"),
                to_date: selected.dateRange[1].endOf("day").format("YYYY-MM-DD"),
                dateType: selected.dateType,
            })
            .then((res) => {
                const data = res.data.data;
                setData(data);
                setMasterState(data);
            })
            .catch((err) => {
                console.log(err);
                message.error("Error fetching Data");
                setMasterState([]);
                setData([]);
            });
        setLoading(false);
    };

    useEffect(() => {
        // This useEffect dosent have the selectedOrg as a dependency because if
        // new org is selected, then new sites will be loded ... and that will trigger getData
        // If we add that dependency, then it will trigger getData twice and the first time with previous org's sites
        if (!selected?.sites?.length) {
            setMasterState([]);
            setLoading(false);
            return;
        }
        getData();

        // Writing to session storage for persistance
        selected?.sites && sessionStorage.setItem("inwardOutward-siteIds", JSON.stringify(selected.sites));
        selected?.dateRange && sessionStorage.setItem("inwardOutward-dateRange", JSON.stringify(selected.dateRange));
    }, [selected.sites, selected.dateRange, selected.inwardOrOutward, selected.dateType]);
    // }, [selectedOrg.orgId, selected.sites, selected.date])

    // This is just for UI loading
    useEffect(() => {
        if (selectedOrg.orgId) {
            setLoading(true);
        }
    }, [selectedOrg.orgId]);

    const [boxNo, setBoxNo] = useState();
    const [box_data, setBoxData] = useState([]);
    const navigate = useNavigate();

    const getBoxData = async () => {
        setLoading(true);
        await axios
            .get(`/reports/stock_tf_id_against_box?box_no=${boxNo}&inward_outward=${selected.inwardOrOutward}`)
            .then((res) => {
                const box_data = res.data.data;
                // window.location.href = `/inventory/inward-outward/${box_data?.stock_transfer_id}?orgId=${data?.o_id}&tab=dashboard`;
                navigate(`/inventory/inward-outward/${box_data?.stock_transfer_id}?orgId=${data?.o_id}&tab=box-wise`);
            })
            .catch((err) => {
                console.log(err);
                message.error(`Box not Found in ${selected.inwardOrOutward}`);
                // setMasterState([]);
                setBoxData([]);
            });
        setLoading(false);
    };

    useEffect(
        () => {
            if (!boxNo) {
                setLoading(false);
                return;
            }
        },
        [boxNo],
        [selected.inwardOrOutward]
    );

    const handleBoxNoChange = () => {
        getBoxData();
    };

    /*
    stock_transfer_id: 1066,
    reference_no: "DCO/00000816/23-24",
    reference_dt: "2023-04-06",
    other_details: null,
    site_id: 15,
    status: "pending",
    createdt: "2023-04-06T19:19:56.662839",
    updatedt: "2023-04-06T19:19:56.662847",
    inward_outward: "inward",
    process_id: null,
    from_site_id: 18,
    is_processed: null,
    is_pushed: null,
    ref_stf_id: 1065,
    epc_matched: 1,
    ref_site_id: null,
    site_name: "GZB-CM3-GZB",
    site_code: "4",
    description: "",
    address_line1: "",
    address_line2: "",
    city_id: 0,
    area_id: 12,
    o_id: 3,
    is_deleted: 0,
    is_active: 1,
    created_by: 2,
    created_time: "2023-03-20T17:20:20.884040",
    updated_by: 1,
    updated_time: "2023-03-31T12:39:55.926018",
    state_id: 0,
    country_id: 0,
    comments: "",
    temp_field_1: "",
    temp_field_2: "",
    temp_field_3: "",
    region_id: 4,
    longitude: "",
    latitude: "",
    m_site_type: null,
    zone: null,
    inward_site: "GZB-CM3-GZB",
    outward_site: "OKHLA-WH-CMWH",
    */

    const statusColorMap = { pending: "#cf1322", done: "#389e0d", scanned: "#faad14" };

    const handleChange = (value) => {
        setSelectedKey("dateType", value);
    };

    const columns = useMemo(() =>
        [
            {
                title: "ID",
                dataIndex: "stock_transfer_id",
                key: "stock_transfer_id",
                defaultSortOrder: "descend",
                sorter: (a, b) => a.stock_transfer_id - b.stock_transfer_id,
                width: 60,
            },
            {
                title: "Created Date",
                dataIndex: "reference_dt",
                key: "reference_dt",
            },
            {
                title: "Scanned Date",
                dataIndex: "updatedt",
                key: "updatedt",
            },
            {
                title: "Reference No",
                dataIndex: "reference_no",
                key: "reference_no",
            },
            {
                title: "Site",
                dataIndex: "site_name",
                key: "site_name",
            },
            // {
            //     title: "To Site",
            //     dataIndex: "inward_site",
            //     key: "site_id",
            //     hidden: selected.inwardOrOutward !== "outward",
            // },
            {
                title: "Reference Site",
                dataIndex: "reference_site",
                key: "reference_site",
            },
            // {
            //     title: "From Site",
            //     dataIndex: "outward_site",
            //     key: "site_id",
            //     hidden: selected.inwardOrOutward !== "inward",
            // },
            {
                title: "Status",
                dataIndex: "status",
                key: "status",
                filters: filterOptions.status,
                render: (text, record) => (
                    <Tag color={statusColorMap[text] || "#000000"} key={record.status} style={{ fontWeight: "700" }}>
                        {text?.toUpperCase()}
                    </Tag>
                ),
                onFilter: (value, record) => record.status == value,
                filterSearch: true,
            },
            {
                title: "Scanned Count",
                dataIndex: "percentage",
                key: "percentage",
                // render: (text, record) => (
                //     (record.percentage.split('/')[0] / record.percentage.split('/')[1] * 100).toFixed(2) + '%'
                // ),
            },
            // {
            //     title: "EPC Matched",
            //     dataIndex: "epc_matched",
            //     key: "epc_matched",
            // },
            {
                title: "Actions",
                render: (text, record) => (
                    <div className="actions-outer-div">
                        <Button type={editButtonType} className="actions-button">
                            <Link to={`${editPath}/${record.stock_transfer_id}`}>View</Link>
                        </Button>
                    </div>
                ),
                width: "80px",
            },
        ].filter((column) => !column.hidden)
    );

    return (
        <div className="my-form-outer">
            <div className="my-form-header">
                <span className="my-form-title">
                    Stock {selected.inwardOrOutward === "outward" ? "Outward" : "Inward"} Sessions
                </span>
            </div>


            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Space>
                    <InputWithLabel label={"Find box"}>
                        <Input
                            type="text"
                            value={boxNo}
                            onChange={(e) => setBoxNo(e.target.value)}
                            placeholder="Enter Box Number"
                            style={{ width: "100%" }}
                        />
                    </InputWithLabel>
                    <InputWithLabel
                        label={<>&nbsp;</>}>
                        <Button type="primary" onClick={handleBoxNoChange} loading={loading}>
                            Search
                        </Button>
                    </InputWithLabel>
                </Space>

                {permissions?.import_stock_transfer && <ImportPOFile inwardOrOutward={selected.inwardOrOutward} getData={getData} />}

            </div>


            <div className="my-table-filter-row">
                <div className="my-form-multiple-inline-input">
                    {/* Read documentation inside DateRange for set methods */}
                    <DateRange
                        selectedOrg={selectedOrg}
                        value={selected.dateRange}
                        setValue={(value) => {
                            setSelectedKey("dateRange", value);
                        }}
                    />
                    <InputWithLabel label="Select Date Type">
                        <Select
                            value={selected.dateType}
                            style={{
                                width: 120,
                                float: "left",
                                marginRight: "15px",
                            }}
                            onChange={handleChange}
                            options={[
                                {
                                    value: "created",
                                    label: "Created Date",
                                },
                                {
                                    value: "scanned",
                                    label: "Scanned Date",
                                },
                            ]}
                        />
                    </InputWithLabel>
                    <SiteTreeMultiSelect
                        selectedOrg={selectedOrg}
                        value={selected.sites}
                        setValue={(value) => {
                            setSelectedKey("sites", value);
                        }}
                    />
                </div>
                <div className="actions-outer-div" style={{ alignItems: "flex-end" }}>
                    <SearchComponent
                        masterState={masterState}
                        state={data}
                        setState={setData}
                        searchOptions={[
                            { keyName: "reference_no", label: "Reference No" },
                            { keyName: "site_name", label: "Site Name" },
                            { keyName: "status", label: "Status" },
                            { keyName: "reference_site", label: "Reference Site" },
                            { keyName: "updatedt", label: "Updated Date" },
                            // if inwardOrOutward is inward, then show outward_site
                            // if inwardOrOutward is outward, then show inward_site
                            // selected.inwardOrOutward === "inward" ? { keyName: "reference_site", label: "Reference Site" } : { keyName: "inward_site", label: "To Site" },
                            { keyName: "stock_transfer_id", label: "Stock Transfer ID" },
                        ]}
                        isLabelInline={false}
                    />
                    <ExportToExcelButton
                        fileName={`Stock ${selected.inwardOrOutward === "outward" ? "Outward" : "Inward"
                            } Sessions ${selected.dateRange[0].format("DD")} to ${selected.dateRange[1].format("DD MMM")}`}
                        sheets={[{ sheetName: "Stock Sessions", data: data, columns: columns.slice(0, -1) }]}
                    />

                </div>
            </div>
            <Table
                columns={columns}
                dataSource={data}
                loading={loading}
                size="small"
                pagination={{
                    position: ["bottomRight"],
                    // position: ['topRight'],
                    showSizeChanger: true,
                    defaultPageSize: parseInt(sessionStorage.getItem("inwardOutward-tablePageSize") || 10),
                    defaultCurrent: parseInt(sessionStorage.getItem("inwardOutward-tableCurrentPage") || 1),
                }}
                onChange={(pagination, filters, sorter, extra) => {
                    // console.log('params', pagination, filters, sorter, extra);
                    sessionStorage.setItem("inwardOutward-tablePageSize", pagination.pageSize);
                    sessionStorage.setItem("inwardOutward-tableCurrentPage", pagination.current);
                }}
            />
        </div>
    );
}

